// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportsView_container__bA7dF {
  width: 85%;
  padding: 30px;
  margin-left: auto;
  text-align: left;
}

.ReportsView_header__k7wZL {
  width: 65%;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  position: relative;
  padding-bottom: 12px;
}

.ReportsView_header__k7wZL::before {
  content: '';
  position: absolute;
  bottom: 11px;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #e0e0e0;
}

.ReportsView_tabButton__lkS-c {
  position: relative;
  background: none;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ReportsView_tabButton__lkS-c:hover {
  background-color: #f0f0f0;
  border-radius: 6px;
}

.ReportsView_active__56Qft {
  color: rgba(29, 135, 82, 1);
}

.ReportsView_active__56Qft::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: rgba(29, 135, 82, 1);
}
`, "",{"version":3,"sources":["webpack://./src/styles/ReportsView.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC","sourcesContent":[".container {\n  width: 85%;\n  padding: 30px;\n  margin-left: auto;\n  text-align: left;\n}\n\n.header {\n  width: 65%;\n  display: flex;\n  margin-bottom: 20px;\n  justify-content: space-between;\n  position: relative;\n  padding-bottom: 12px;\n}\n\n.header::before {\n  content: '';\n  position: absolute;\n  bottom: 11px;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: #e0e0e0;\n}\n\n.tabButton {\n  position: relative;\n  background: none;\n  border: none;\n  padding: 10px 16px;\n  font-size: 16px;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tabButton:hover {\n  background-color: #f0f0f0;\n  border-radius: 6px;\n}\n\n.active {\n  color: rgba(29, 135, 82, 1);\n}\n\n.active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: rgba(29, 135, 82, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReportsView_container__bA7dF`,
	"header": `ReportsView_header__k7wZL`,
	"tabButton": `ReportsView_tabButton__lkS-c`,
	"active": `ReportsView_active__56Qft`
};
export default ___CSS_LOADER_EXPORT___;
